export enum ResourceType {
	Image = 0,
	Video = 10,
}